<template>
  <div class="agreement">
    <Header title="应用权限说明"></Header>
    <p class="ql-title">应用权限说明</p>
    <p class="ql-align-justify">
      <strong>1.</strong
      >为保障大有空间<strong>APP</strong>能实现与安全稳定运行之目的，我们可能会申请或使用操作系统的相关权限:为保障您的知情权，我们通过下列列表将产品可能申请，使用的相关操作系统权限进行展示，您可以根据实际需要对相关权限进行管理;
    </p>
    <p class="ql-align-justify">
      <strong>2.</strong
      >根据产品的升级，申请、使用权限的类型与目的可能会有变动，我们将及时根据这些变动对列表进行调整以确保您及时获悉权限的申请与使用情况:
    </p>
    <p class="ql-align-justify">
      <strong>3.</strong
      >请您知悉，我们为业务与产品的功能与安全需要，我们可能也会使用第三方<strong>SDK</strong>，这些第三方也可能会申请或使用相关操作系统权限:
    </p>
    <p class="ql-align-justify">
      <strong>1.</strong>读取SD卡中的内容(读取存储空间/照片权限)
    </p>
    <p class="ql-align-justify">权限说明:提供读取手机储存空间内数据的功能</p>
    <p class="ql-align-justify">
      使用场景及目的:允许App读取存储中的图片、文件等内容，主要用于帮助您上传图片、文件、在本地记录崩溃日志信息等功能
    </p>

    <p class="ql-align-justify">
      <strong>2.</strong
      >写入/删除<strong>SD</strong>卡中的内容(写入/删除/存储空间/照片权限)
    </p>
    <p class="ql-align-justify">权限说明:提供写入外部储存功能</p>
    <p class="ql-align-justify">
      使用场景及目的:进行读取操作，如选择修改头像上传图片需要
    </p>

    <p class="ql-align-justify">
      <strong>3.</strong>读取手机状态和身份(电话权限、设备权限)
    </p>
    <p class="ql-align-justify">
      权限说明:提供读取手机设备标识等信息，请您放心该权限无法监听、获取您的任何通话内容与信息
    </p>
    <p class="ql-align-justify">
      使用场景及目的:注册成为大有空间<strong>APP</strong>用户、实名认证账号、提供问题诊断排查服务需要用户提供电话号码
    </p>

    <p class="ql-align-justify"><strong>4.</strong>检索正在运行的应用</p>
    <p class="ql-align-justify">权限说明:检测<strong>APP</strong>自身状态</p>
    <p class="ql-align-justify">
      使用场景及目的:用于判断自身<strong>APP</strong>是否处于前台
    </p>

    <p class="ql-align-justify">
      <strong>5.ACCESS_NETWORK_STATE</strong>
    </p>
    <p class="ql-align-justify">权限说明:判断网络连通性</p>
    <p class="ql-align-justify">使用场景及目的:用于判断网络连通性</p>

    <p class="ql-align-justify">
      <strong>6. ACCESS_WIFI_STATE</strong>
    </p>
    <p class="ql-align-justify">权限说明:判断网络连通性</p>
    <p class="ql-align-justify">使用场景及目的:用于判断网络连通性</p>

    <p class="ql-align-justify">
      <strong>7.REQUEST_INSTALL_PACKAGES</strong>
    </p>
    <p class="ql-align-justify">
      <strong>权限说明:自动升级 </strong>
    </p>
    <p class="ql-align-justify">使用场景及目的:用于应用自动升级时的安装请求</p>

    <p class="ql-align-justify"><strong>8.</strong>读取外置存储卡</p>
    <p class="ql-align-justify">
      权限说明:提供读取手机外置储存空间内数据的功能
    </p>
    <p class="ql-align-justify">
      使用场景及目的:用于对用户选择外置存储卡上的文件进行读取操作，如选择图片上传
    </p>

    <p class="ql-align-justify">
      <strong>9.INTERNET </strong>
    </p>
    <p class="ql-align-justify">权限说明:网络链接权限</p>
    <p class="ql-align-justify">使用场景及目的:用于网络链接</p>

    <p class="ql-align-justify">
      <strong>10.录音权限 </strong>
    </p>
    <p class="ql-align-justify">权限说明：提供手机录音功能</p>
    <p class="ql-align-justify">使用场景及目的：用于应用内语音转文字功能需要</p>

    <p class="ql-align-justify">
      <strong>11.CHANGE_NETWORK_STATE </strong>
    </p>
    <p class="ql-align-justify">权限说明:登录时切换网络</p>
    <p class="ql-align-justify">使用场景及目的:用于登录时切换网络</p>

    <p class="ql-align-justify">
      <strong>12.VIBRATE </strong>
    </p>
    <p class="ql-align-justify">权限说明:震动提醒</p>
    <p class="ql-align-justify">使用场景及目的:收到通知震动提醒</p>

    <p class="ql-align-justify">
      <strong>13.com.asus.msa.SupplementaryDID.ACCESS</strong>
    </p>
    <p class="ql-align-justify">
      获取设备标识信息<strong>oaid</strong>在华硕设备上需要用到的权限
    </p>

    <p class="ql-align-justify"><strong>iOS</strong>操作系统应用权限列表</p>

    <p class="ql-align-justify">
      <strong>1.NSCameraUsageDescription </strong>
    </p>
    <p class="ql-align-justify">权限说明：使用摄像头</p>
    <p class="ql-align-justify">
      使用场景及目的：使用头像拍摄、扫一扫、保存照片等功能
    </p>

    <p class="ql-align-justify">
      <strong>2.NSLocationAlwaysAndWhenInUseUsageDescription </strong>
    </p>
    <p class="ql-align-justify">
      权限说明：获取用户地理位置信息（<strong>App</strong>不被使用时也会获取）
    </p>
    <p class="ql-align-justify">
      使用场景及目的：用于获取本地<strong>WiFi</strong>名称以及个人信息所在地的功能
    </p>

    <p class="ql-align-justify">
      <strong>3.NSLocationWhenInUseUsageDescription </strong>
    </p>
    <p class="ql-align-justify">
      权限说明：获取用户地理位置信息（仅<strong>App</strong>使用时获取）
    </p>
    <p class="ql-align-justify">
      使用场景及目的：用于获取本地<strong>WiFi</strong>名称以及个人信息所在地的功能
    </p>

    <p class="ql-align-justify">
      <strong>4.NSPhotoLibraryAddUsageDescription </strong>
    </p>
    <p class="ql-align-justify">权限说明：向相册中添加图片视频</p>
    <p class="ql-align-justify">使用场景及目的：用于存储图片或视频文件的功能</p>

    <p class="ql-align-justify">
      <strong>5.NSPhotoLibraryUsageDescription </strong>
    </p>
    <p class="ql-align-justify">权限说明：读取相册内容</p>
    <p class="ql-align-justify">
      使用场景及目的：保存照片或视频、上传文件等功能
    </p>

    <p class="ql-align-justify">
      <strong>6.NSUserTrackingUsageDescription </strong>
    </p>
    <p class="ql-align-justify">权限说明：获取设备标识以识别设备信息</p>
    <p class="ql-align-justify">
      使用场景及目的：开启后可为您进行个性化的内容推荐
    </p>
    <p><br /></p>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>
<style lang="less" scoped>
@import "./agreement.less";
</style>
